export function buildCompanySettingsScopeKey(
    tenantId: number | string | null | undefined,
    tenantSlug: string | null | undefined,
    companyId: number | string | null | undefined,
): string | null {
    if (tenantId === null || tenantId === undefined || !tenantSlug || companyId === null || companyId === undefined) {
        return null;
    }

    return `${tenantId}:${tenantSlug}:${companyId}`;
}
